import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_AMBER } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/cradles.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/cradles-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/cradles-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/cradles-extreme.circles.json' with { type: 'json' };

export const CRADLES_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'cradles',
  baseTitle: "Cradles",
  description: "Sub Urban's dark alt-pop. Snappy snares and vocal-led groove, wave-mode interpretation.",
  difficulty: 3,
  palette: PALETTE_AMBER,
  audioSrc: '/audio/waves/cradles.mp3',
  attribution: "\"Cradles\" by Sub Urban [NCS Release] - https://ncs.io/Cradles",
  mapper: "DaKawaliKid",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 80, offsetMs: 0, totalBeats: 83 },
    hard: { bpm: 80, offsetMs: 0, totalBeats: 83 },
    extreme: { bpm: 80, offsetMs: 0, totalBeats: 83 },
  },
});
